import { render, staticRenderFns } from "./navigation-public.vue?vue&type=template&id=15461906"
import script from "./navigation-public.vue?vue&type=script&lang=js"
export * from "./navigation-public.vue?vue&type=script&lang=js"
import style0 from "./navigation-public.vue?vue&type=style&index=0&id=15461906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports